import brunaPic from "@/public/images/artists/bruna.png";
import { Artist } from "@/types/types";

export const bruna = {
  id: "140",
  name: "Bruna",
  image: brunaPic,
  description: `Bruna's voice is light and airy, infused with a youthful nonchalance that lends it an ethereal and contemporary aura. Its delicate texture effortlessly crafts a modern, dreamlike vibe, making it both versatile and mesmerizing in any setting.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fbruna-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Latin",
        "Pop",
        "Dance",
        "RnB",
        "Ethereal",
        "Unprocessed",
        "Airy",
        "Falsetto",
      ],
      secondary: ["Alluring", "Youthful"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 56,
        high: 74,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
